module.exports = require('./getOnyxVariation')
